import React from "react";
import HaccpHeader from "../../../components/Compliance Certificates/HACCP/HaccpHeader";
import HaccpInfoContainer from "../../../components/Compliance Certificates/HACCP/HaccpInfoContainer";

const Haccp = () => {
  return (
    <div>
      <HaccpHeader />
      <HaccpInfoContainer />
    </div>
  );
};

export default Haccp;
